import { Box, Image, useColorModeValue } from '@chakra-ui/react';
import smolNavLight from '@/assets/logos/smolNavLight.svg';
import smolNavDark from '@/assets/logos/smolNavDark.svg';

/** Full stacked mark (10 + TEAMS); fits within the 64px nav row. */
const NAV_LOGO_HEIGHT = 9;

export function SiteNavLogo(props: { onClick: () => void; ariaLabel: string }) {
  const logoSrc = useColorModeValue(smolNavLight, smolNavDark);

  return (
    <Box
      as='button'
      type='button'
      onClick={props.onClick}
      flexShrink={0}
      display='flex'
      alignItems='center'
      alignSelf='center'
      cursor='pointer'
      aria-label={props.ariaLabel}
      border='none'
      outline='none'
      bg='transparent'
      p={0}
      m={0}
      lineHeight={0}
      overflow='visible'
      sx={{
        appearance: 'none',
        WebkitAppearance: 'none',
        boxShadow: 'none',
        _focus: { boxShadow: 'none' },
        _focusVisible: {
          boxShadow: 'none',
          outline: '2px solid',
          outlineColor: 'blue.400',
          outlineOffset: '2px',
        },
      }}
    >
      <Image
        h={NAV_LOGO_HEIGHT}
        maxH={NAV_LOGO_HEIGHT}
        w='auto'
        src={logoSrc}
        alt=''
        role='presentation'
        objectFit='contain'
        objectPosition='left center'
        display='block'
      />
    </Box>
  );
}
